import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { ModalVariantEnum } from '~/component/modal/enums/modal-variant.enum';
import { ModalComponent } from '~/component/modal/modal.component';

import { ModalEditTimeslotsModesEnum } from './modal-edit-timeslots-modes.enum';
import { CtaButtonTypeEnum } from '../call-to-action/enums/button-type.enum';
import { VtmnPlayIconTypeEnum } from '../vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { VtmnPlayButtonShapeEnum } from '../buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';

@Component({
  selector: 'app-modal-edit-timeslots',
  templateUrl: './modal-edit-timeslots.component.html',
  styleUrls: ['./modal-edit-timeslots.component.scss'],
})
export class ModalEditTimeslotsComponent {
  @Input() public isLastTimeslot: boolean;
  @Input() public updateMode = ModalEditTimeslotsModesEnum.EDITION;

  @Output() public updateAllTimeslots = new EventEmitter<void>();
  @Output() public updateSelectedTimeslots = new EventEmitter<void>();
  @Output() public updateTimeslot = new EventEmitter<void>();

  @ViewChild('saveModal') public saveModal: ModalComponent;

  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly iconType = VtmnPlayIconTypeEnum;
  public readonly modalVariant = ModalVariantEnum;
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;

  constructor(private readonly translateService: TranslateService) {}

  public closeModal(): void {
    this.saveModal.hide();
  }

  public openModal(): void {
    this.saveModal.show();
  }

  public translateKey(key: string): string {
    const baseKey = 'organizer.edit_timeslots.modal.';

    return this.translateService.instant(
      `${baseKey}${this.updateMode.toLowerCase()}.${key}`
    );
  }
}
